
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../../app/applicationSlice";
import { RootThunkApi } from "../../../../app/store";
import { ExcuteTableList, ExcuteTableListParams, ExecuteSubmit, ExecuteSubmitParams, ExecutionDetail, ExecutionDetailParams, MedicalRecipeDetail, PatientDataList, PatientDataParams } from "../../../../services/unexecutedPrescription";

// 列表
export const getPatientDataList = createAsyncThunk<
  void,
  PatientDataParams,
  RootThunkApi<void>
>("medicalstation/getPatientDataList", async (params, api) => {
  return sendAsync( PatientDataList(params), api);
});


// 获取右侧详情
export const getMedicalRecipeDetail = createAsyncThunk<
  void,
  PatientDataParams,
  RootThunkApi<void>
>("medicalstation/getMedicalRecipeDetail", async (params, api) => {
  return sendAsync( MedicalRecipeDetail(params), api);
});

// 查询单个执行详情
export const getExecutionDetail = createAsyncThunk<
  void,
  ExecutionDetailParams,
  RootThunkApi<void>
>("medicalstation/peddingMedicalTreatmentRecordDetail", async (params, api) => {
  return sendAsync( ExecutionDetail(params), api);
});

// 执行记录
export const getExcuteRecordTableList = createAsyncThunk<
  void,
  ExcuteTableListParams,
  RootThunkApi<void>
>("medicalstation/ExcuteTableList", async (params, api) => {
  return sendAsync(ExcuteTableList(params), api);
});

// 保存
export const getExecuteSubmit = createAsyncThunk<
  void,
  ExecuteSubmitParams,
  RootThunkApi<void>
>("medicalstation/getExecuteSubmit", async (params, api) => {
  return sendAsync( ExecuteSubmit(params), api);
});